import React from 'react'
import './spinner.css'

const Spinner = () => {
  return (
    <div className="loadingio-spinner-rolling-yxl20u3w7ue">
      <div className="ldio-q1dhsoj7dmh">
        <div></div>
      </div>
    </div>
  )
}

export default Spinner 
